export const storeFormFeedback = {
  namespaced: true,

  state: {
    lat: 0,
    lng: 0,
    country: '',
    region: '',
  },

  actions: {
    updateLatLng ({ commit }, latLng) {
      commit('updateLat', latLng.lat)
      commit('updateLng', latLng.lng)
    },

    updateCountry ({ commit }, country) {
      commit('updateCountry', country)
    },

    updateRegion ({ commit }, region) {
      commit('updateRegion', region)
    },

    resetForm({ commit }) {
      commit('updateLat', 0)
      commit('updateLng', 0)
      commit('updateCountry', '')
      commit('updateRegion', '')
    }
  },

  mutations: {
    updateLat (state, lat) { state.lat = lat },
    updateLng (state, lng) { state.lng = lng },
    updateCountry (state, country) { state.country = country },
    updateRegion (state, region) { state.region = region }
  }
}